import { useState, useEffect } from 'react';

import * as FullStory from '@fullstory/browser';

export const FullStoryIntegration = props => {
  useFullStory(props);
  return null;
};

const useFullStory = ({ orgId, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const { userId } = props;

  useEffect(() => {
    if (!orgId) return;
    FullStory.init({ orgId }, () => setLoaded(true));
  }, []);

  useEffect(() => {
    if (!loaded) return;
    if (userId === 0) {
      return;
    }
    identifyFullStoryUser(props);
  }, [loaded, userId]);
};

const identifyFullStoryUser = ({
  userId,
  dotNumber,
  carrierName,
  emailAddr,
  firstName,
  lastName,
}) => {
  FullStory.identify(String(userId), {
    // User specific
    email: emailAddr,
    user_first_name_str: firstName,
    user_last_name_str: lastName,
    user_id_str: userId,
    // Carrier specific
    carrier_dot_number_str: dotNumber,
    carrier_name_str: carrierName,
  });
};
